// Serander: einfacher Sprachumschalter (Text-Button statt Dropdown-Select)
(function () {
  function buildButton(select) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'serander-lang-switch';
    button.setAttribute('aria-label', 'Sprache wechseln / Switch language');

    function otherOption() {
      var options = Array.prototype.slice.call(select.options);
      return options.find(function (opt) {
        return opt.value.toLowerCase() !== select.value.toLowerCase();
      });
    }

    function updateLabel() {
      var other = otherOption();
      button.textContent = other ? other.value.toUpperCase() : '';
    }

    updateLabel();

    button.addEventListener('click', function () {
      var other = otherOption();
      if (!other) return;
      select.value = other.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    return button;
  }

  function init() {
    document.querySelectorAll('.localization-form__select').forEach(function (select) {
      if (select.dataset.seranderEnhanced) return;
      select.dataset.seranderEnhanced = 'true';

      var wrapper = select.closest('.language-selector');
      if (!wrapper) return;

      var button = buildButton(select);
      wrapper.style.display = 'none';
      wrapper.insertAdjacentElement('beforebegin', button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on dynamic re-renders (theme editor / section reloads)
  document.addEventListener('shopify:section:load', init);
})();
